<template>
  <header class="systems-communications-header">
    <h2>Configuração de emails de notificação</h2>
    <div>
      <i
        v-tooltip="$t('message.email.message.validateDomains')"
        class="mdi mdi-settings pointer system-comunnications-header-action"
        @click="openDomainValidation"
      ></i>

      <domain-modal :showing.sync="showingDomainValidationModal" />
    </div>
  </header>
</template>
<script>
import DomainModal from "@components/modules/domain/modal/DomainModal";

export default {
  components: { DomainModal },

  data() {
    return {
      showingDomainValidationModal: false,
    };
  },

  methods: {
    openDomainValidation() {
      this.showingDomainValidationModal = true;
    },
  },

  computed: {},
};
</script>

<style lang="scss" scoped>
.systems-communications-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .system-comunnications-header-action {
    font-size: 25px;
    color: #707070;
    margin-right: 10px;
  }
}
</style>
